// This file is automatically generated. Do not edit manually.

import { SafetyControlSurveyNoteView } from "src/api/generated/erp/db/types/tables/safetyControlSurveyNoteView";
import { SafetyControlSurveyNote } from "src/api/generated/erp/db/types/tables/safetyControlSurveyNote";
import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { SafetyControlSurveyNoteCategory } from "src/api/generated/erp/db/types/tables/safetyControlSurveyNoteCategory";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SafetyControlSurveyNoteApi {
	export async function getNotes(args: {
		safetyControlSurveyId: number;
	}): Promise<Array<SafetyControlSurveyNoteView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyNotes/getNotes",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as Array<SafetyControlSurveyNoteView>;
	}

	export async function getNoteFormInitData(): Promise<SafetyControlSurveyNoteApi_NoteFormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyNotes/getNoteFormInitData",
			method: "POST",
			data: {},
		});
		return response as SafetyControlSurveyNoteApi_NoteFormInitData;
	}

	export async function insert(args: {
		note: SafetyControlSurveyNote;
		files: Array<FrontendUploadFileHandle>;
	}): Promise<SafetyControlSurveyNote> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyNotes/insert",
			method: "POST",
			data: {
				note: args.note,
				files: args.files,
			},
		});
		return response as SafetyControlSurveyNote;
	}

	export async function update(args: {
		note: SafetyControlSurveyNote;
		files: Array<FrontendUploadFileHandle>;
	}): Promise<SafetyControlSurveyNote> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyNotes/update",
			method: "POST",
			data: {
				note: args.note,
				files: args.files,
			},
		});
		return response as SafetyControlSurveyNote;
	}

	export async function delete_(args: { safetyControlSurveyNoteId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyNotes/delete",
			method: "POST",
			data: {
				safetyControlSurveyNoteId: args.safetyControlSurveyNoteId,
			},
		});
		return response as void;
	}
}

export interface SafetyControlSurveyNoteApi_NoteFormInitData {
	categoryOptions: Array<SafetyControlSurveyNoteCategory>;
}
